import {useEffect} from 'react'
import {useUserStore} from '../../users/states/user.state'
import {useTrxResiFormStore} from '../states/trx-resi.state'
import {KTSVG} from '../../../../../_metronic/helpers'
import FormsComponent from '../../../../helpers/forms.component'

const TrxResiModalComponent = () => {
  const {getUsers, userSelectDatas} = useUserStore()
  const {setFormSelectData} = useTrxResiFormStore()

  useEffect(() => {
    document.body.classList.add('modal-open')
    getUsers({
      page: 0,
      size: 100,
      filters: `["role_id", "in", ["822b5176-7215-404c-acb9-ac20c793a63e"]]`,
    })
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    if (userSelectDatas?.length > 0) {
      setFormSelectData(1, userSelectDatas)
    }
  }, [userSelectDatas])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_properties'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-800px'>
          <div className='modal-content'>
            <TrxResiModalHeader />

            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <TrxResiModalFormWrapper />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

const TrxResiModalHeader = () => {
  const {setField, formParam} = useTrxResiFormStore()

  return (
    <div className='modal-header'>
      <h2 className='fw-bold'>{formParam?.title}</h2>

      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setField(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
    </div>
  )
}

const TrxResiModalFormWrapper = () => {
  const {forms, setForms, setField, onSubmit} = useTrxResiFormStore()
  return (
    <>
      <form>
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_user_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_user_header'
          data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
          data-kt-scroll-offset='300px'
        >
          <div className='row'>
            <FormsComponent
              forms={forms}
              setForms={setForms}
              uploadFileCb={(e) => console.log(e)}
            />
          </div>
        </div>
        <div className='text-center pt--15'>
          <button
            type='reset'
            onClick={() => setField(undefined)}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            onClick={(e) => {
              e.preventDefault()
              onSubmit()
            }}
          >
            <span className='indicator-label'>Submit</span>
          </button>
        </div>
      </form>
    </>
  )
}

export default TrxResiModalComponent
